import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  VisitorInquiryPayload,
  VisitorInquiryRecord,
} from "@project/types/visitor-inquiry";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/visitor-inquiries`;
const SILENT: RequestConfig = { showNotification: false };

class VisitorInquiryService {
  listInquiriesPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<VisitorInquiryRecord>> => {
    return fetchListPage<VisitorInquiryRecord>(`${BASE}/`, query);
  };

  getInquiry = async (
    id: number
  ): Promise<VisitorInquiryRecord | undefined> => {
    const data = await get<
      ApiItemResponse<VisitorInquiryRecord> | VisitorInquiryRecord
    >(`${BASE}/${id}/`, SILENT_LIST);
    return unwrapItem(data);
  };

  createInquiry = async (
    payload: VisitorInquiryPayload
  ): Promise<VisitorInquiryRecord | undefined> => {
    const data = await post<
      ApiItemResponse<VisitorInquiryRecord> | VisitorInquiryRecord,
      VisitorInquiryPayload
    >(`${BASE}/`, payload, SILENT);
    return unwrapItem(data);
  };

  updateInquiry = async (
    id: number,
    payload: Partial<VisitorInquiryPayload>
  ): Promise<VisitorInquiryRecord | undefined> => {
    const data = await patch<
      ApiItemResponse<VisitorInquiryRecord> | VisitorInquiryRecord,
      Partial<VisitorInquiryPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  deleteInquiry = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const visitorInquiryService = new VisitorInquiryService();
